export default import.meta.ROLLDOWN_FILE_URL_gDchvJYEg_PEfG8UvJklmg